import { defineComponent as _defineComponent } from 'vue'
import Checklist from './checklist.vue';
import {ref, onMounted, computed,watch} from 'vue';
import useClickOutside from '@/composables/useClickOutside';
import { useRegistrationStore } from '@/store/registration';
import { useBuilderStore } from "@/store/builder";
import { storeToRefs } from 'pinia';
import { useRouter } from "vue-router";
// import { useUserstate } from '@/store/userstate';
import { UserState } from '@busy-human/hxp-library';
import { useAuth } from '@/store/auth';
// import { useBookings } from '@/store/bookings';
import { analytics  } from "../../../src/util/firebase";
import { logEvent } from "firebase/analytics";
import emitter, { EventTypes, events } from '@/events';
import { isMobile } from './navState';
import { toggleCollapse, collapsed } from "@/components/Navbar/navState";

type builderGroup = {
	teen: string
	parent?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'registration-nav',
  setup(__props, { expose: __expose }) {
  __expose();

const router = useRouter();
const builderStore = useBuilderStore();
const auth = useAuth();


const showDropDown = ref(false);
const builderSelect = ref(null);
useClickOutside(builderSelect, ()=> {
	if(showDropDown.value){
		showDropDown.value = false;
	}
});

const returnToCart = async () => {
	// stateStore.updateState({'stage': UserState.BuilderStage.SHOPPING});

	if(!collapsed.value){
		toggleCollapse();
	}
	logEvent(analytics, "view_cart");
	await router.push({'name': "Shopping Cart"});
};


const registrationStore = useRegistrationStore();
// const bookings = useBookings();

const { totalProgress } = storeToRefs(registrationStore);

function selectBuilder(builderId: string){
	builderStore.selectBuilder(builderId);
	if(router.currentRoute.value.path === "/registration/preferences" && builderStore.currentBuilderRecord?.builderType === "parentBuilder"){
		const pairedBuilder = builderStore.currentBuilderRecord.builderTypeDetails.pairUser;
		if(pairedBuilder){
			builderStore.selectBuilder(pairedBuilder);
		}
	}
	showDropDown.value = false;
}

function openWelcomeBack(){
    emitter.emit('openWelcomeBack');
}

onMounted(()=>{
	//const builder = builderStore.asArray[0];
	const builder = builderStore.selectableBuilders[0];
	if(builder){
		builderStore.selectBuilder(builder);
	}
});

const __returned__ = { router, builderStore, auth, showDropDown, builderSelect, returnToCart, registrationStore, totalProgress, selectBuilder, openWelcomeBack, Checklist, ref, onMounted, computed, watch, get useClickOutside() { return useClickOutside }, get useRegistrationStore() { return useRegistrationStore }, get useBuilderStore() { return useBuilderStore }, get storeToRefs() { return storeToRefs }, get useRouter() { return useRouter }, get UserState() { return UserState }, get useAuth() { return useAuth }, get analytics() { return analytics }, get logEvent() { return logEvent }, get emitter() { return emitter }, get EventTypes() { return EventTypes }, get events() { return events }, get isMobile() { return isMobile }, get toggleCollapse() { return toggleCollapse }, get collapsed() { return collapsed } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})